import Vue from "vue";
import { Prop, Inject, Component } from "vue-property-decorator";
import { TreeNode } from "element-ui/types/tree";

@Component
export default class TreeProps extends Vue {
  @Inject()
  protected bus: any;

  //#region el-tree props
  @Prop()
  protected data!: any[];
  @Prop()
  protected emptyText!: string;

  @Prop({ default: "Id" })
  protected nodeKey!: string;
  @Prop({
    default: () => {
      return {
        ["label"]: "Name"
      };
    }
  })
  protected props!: IGhTreeDataOption;

  @Prop()
  protected renderAafterExpand!: boolean;
  @Prop()
  protected load!: (node: TreeNode<any, any>, resolve: any) => void;
  @Prop()
  protected highlightCurrent!: boolean;
  @Prop()
  protected defaultExpandAll!: boolean;
  @Prop()
  protected expandOnClickNode!: boolean;
  @Prop()
  protected checkOnClickNode!: boolean;
  @Prop()
  protected autoExpandParent!: boolean;
  @Prop()
  protected defaultExpandedKeys!: any[];
  @Prop()
  protected showCheckbox!: boolean;
  @Prop()
  protected checkStrictly!: boolean;
  @Prop()
  protected defaultCheckedKeys!: any[];
  @Prop()
  protected currentNodeKey!: string | number;
  @Prop()
  protected accordion!: boolean;
  @Prop()
  protected indent!: number;
  @Prop()
  protected iconClass!: string;
  @Prop()
  protected lazy!: boolean;
  @Prop()
  protected draggable!: boolean;
  @Prop()
  protected allowDrag!: (node: TreeNode<any, any>) => boolean;
  //#endregion

  //#region get Props
  public get Props(): IGhTreeProps {
    return {
      data: this.data,
      emptyText: this.emptyText,
      nodeKey: this.nodeKey,
      props: this.props,
      renderAafterExpand: this.renderAafterExpand,
      load: this.load,
      highlightCurrent: this.highlightCurrent,
      defaultExpandAll: this.defaultExpandAll,
      expandOnClickNode: this.expandOnClickNode,
      checkOnClickNode: this.checkOnClickNode,
      autoExpandParent: this.autoExpandParent,
      defaultCheckedKeys: this.defaultCheckedKeys,
      showCheckbox: this.showCheckbox,
      checkStrictly: this.checkStrictly,
      currentNodeKey: this.currentNodeKey,
      accordion: this.accordion,
      indent: this.indent,
      iconClass: this.iconClass,
      lazy: this.lazy,
      draggable: this.draggable,
      allowDrag: this.allowDrag
    };
  }
  //#endregion
}
